import ShiritoriLogoPath from '../assets/image/shiritori-main.webp';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ReturnToGame } from '../components/home/return-to-game';
import { Button } from '../components/home/buttons';

export function HowToPlay() {
    const { t } = useTranslation();

    function translateRich(key: string): React.ReactNode {
        const words = t(`howToPlay.${key}`).split(' ');

        function innerText(segment: string): string {
            return segment.substring(2, segment.length - 1).replaceAll('_', ' ');
        }

        return (
            <>
                {words.map((word, i) => {
                    if (word.startsWith('k|')) {
                        return (<Keyword key={i} text={innerText(word) + ' '} />);
                    } else if (word.startsWith('b|')) {
                        return (<strong key={i} className="">{innerText(word)} </strong>);
                    } else if (word.startsWith('i|')) {
                        return (<em key={i}>{innerText(word)} </em>);
                    } else if (word.startsWith('e|')) {
                        return (<span key={i} className="text-center p-2 m-2 rounded">{innerText(word)} </span>)
                    }
                    return word + ' ';
                })}
            </>
        );
    }

    return (
        <>
            <Link to="/" className="h-1/4 w-[30vh] hover:bg-slate-50/10 outline-white/35">
                <img src={ShiritoriLogoPath} alt={t('common.txtLogoAlt')} className="w-full h-full drop-shadow-heavy object-contain" />
            </Link>

            <div className="w-full max-w-prose px-12 select-text">
                <ReturnToGame />
                <h1 className="text-3xl font-medium my-6 text-center">{t('howToPlay.title')}</h1>

                <p className="my-4 text-base">{translateRich('description1')}</p>
                <p className="my-4 text-base">{translateRich('description2')}</p>

                <Heading>{translateRich('gameSetup.title')}</Heading>
                <ul className="list-disc px-6">
                    <li className="text-base mb-2">{translateRich('gameSetup.p1')}</li>
                    <li className="text-base mb-2">{translateRich('gameSetup.p2')}</li>
                    <li className="text-base mb-2">{translateRich('gameSetup.p3')}</li>
                    <li className="text-base mb-2">{translateRich('gameSetup.p4')}</li>
                </ul>

                <Heading>{translateRich('objective.title')}</Heading>
                <p className="my-4 text-base">{translateRich('objective.p1')}</p>

                <Heading>{translateRich('wordRules.title')}</Heading>
                <p className="my-4 text-base">{translateRich('wordRules.p1')}</p>
                <p className="my-4 text-base">{translateRich('wordRules.p2')}</p>
                <p className="my-4 text-base">{translateRich('wordRules.p3')}</p>
                <ul className="list-disc px-6">
                    <li className="text-base mb-2">{translateRich('wordRules.li1')}</li>
                    <li className="text-base mb-2">{translateRich('wordRules.li2')}</li>
                    <li className="text-base mb-2">{translateRich('wordRules.li3')}</li>
                    <li className="text-base mb-2">{translateRich('wordRules.li4')}</li>
                    <li className="text-base mb-2">{translateRich('wordRules.li5')}</li>
                </ul>
                <p className="my-4 text-base">{translateRich('wordRules.p4')}</p>

                <Heading>{translateRich('turnFlow.title')}</Heading>
                <p className="my-4 text-base">{translateRich('turnFlow.p1')}</p>
                <p className="my-4 text-base">{translateRich('turnFlow.p2')}</p>
                <p className="my-4 text-base">{translateRich('turnFlow.p3')}</p>

                <Heading>{translateRich('boardFlow.title')}</Heading>
                <p className="my-4 text-base">{translateRich('boardFlow.p1')}</p>
                <p className="my-4 text-base">{translateRich('boardFlow.p2')}</p>
                <p className="my-4 text-base">{translateRich('boardFlow.p3')}</p>
                <p className="my-4 text-base">{translateRich('boardFlow.p4')}</p>

                <Heading>{translateRich('summary.title')}</Heading>
                <p className="my-4 text-base">{translateRich('summary.p1')}</p>
                <p className="my-4 text-base">{translateRich('summary.p2')}</p>

                <div className="pt-6 pb-12 text-center">
                    <Link to="/create" className="">
                        <Button className="w-1/2">{t('howToPlay.btnPlayNow')}</Button>
                    </Link>
                </div>
            </div>
        </>
    );
}

function Keyword({ text }: { text: string }) {
    return (
        <span className="italic font-medium text-red-600">{text}</span>
    );
}

function Heading({ children }: { children: React.ReactNode }) {
    return (
        <h2 className="my-8 text-2xl">{children}</h2>
    );
}
